import { staticPageData } from './static-page.data';

export const staticPageService = {
  getStaticPage: (slug: string) => staticPageData.getStaticPage(slug),
};
